// kit, order, set, product, pillow
$(() => {
    $(document).on("click", ".tab-head", function () {
        const dataTabId = $(this).data("tab");
        $(this).addClass("active").siblings().removeClass("active");
        $(this)
            .closest(".tabs")
            .find(`.tab-cont[data-tab="${dataTabId}"]`)
            .fadeIn()
            .addClass("active")
            .siblings()
            .hide()
            .removeClass("active");
    });
});
